import { useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export function BulkForm({ onDone, onCancel }) {
  const [form, setForm] = useState({ period: new Date().toISOString().slice(0, 7), due_day: 5 });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/rent-invoices/bulk-generate", {
        period: form.period, due_day: Number(form.due_day),
      });
      toast.success(`Created ${r.data.created} invoice(s), skipped ${r.data.skipped}`);
      onDone();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 p-6 grid md:grid-cols-3 gap-4" data-testid="bulk-form">
      <div>
        <label className="text-xs uppercase tracking-wider text-slate-500 block mb-2">Period</label>
        <input required type="month" data-testid="bulk-period" className="border border-slate-300 px-4 py-2.5 w-full"
               value={form.period} onChange={(e) => setForm({ ...form, period: e.target.value })} />
      </div>
      <div>
        <label className="text-xs uppercase tracking-wider text-slate-500 block mb-2">Due day</label>
        <input required type="number" min="1" max="28" data-testid="bulk-due-day"
               className="border border-slate-300 px-4 py-2.5 w-full"
               value={form.due_day} onChange={(e) => setForm({ ...form, due_day: e.target.value })} />
      </div>
      <div className="flex items-end gap-3">
        <button data-testid="bulk-save" className="bg-slate-900 text-white px-6 py-2.5">Generate for all active tenants</button>
        <button type="button" onClick={onCancel} className="bg-slate-100 px-6 py-2.5">Cancel</button>
      </div>
    </form>
  );
}
